import { createSelector } from 'reselect';

export const groupsByIdSelector = (state) => state.groups.groupsById;
export const groupIdMaxSelector = (state) => state.groups.groupIdMax;

export const groupIdsSelector = createSelector(
  groupsByIdSelector,
  (groupsById) => Object.keys(groupsById)
);
